<header id="header" class="fixed-top ">
  <div class="container d-flex align-items-center">

    <h1 class="logo me-auto"><a href="index.html">My DVC</a></h1>

    <nav id="navbar" class="navbar">
      <ul>
        <li><a class="nav-link scrollto active" href="#hero">Home</a></li>
        <li><a class="nav-link scrollto" href="#samplecards">Sample Cards</a></li>
        <li><a class="nav-link scrollto" href="#pricing">Pricing</a></li>
        <li><a class="nav-link scrollto" href="#forbusiness">For Business</a></li>
        <li><a class="getstarted-signup scrollto" href="/signup">Sign Up</a></li>
        <li><a class="getstarted-login scrollto" href="/login">Login</a></li>
      </ul>
      <i id="mob" (click)="mob_click()" class="bi bi-list mobile-nav-toggle"></i>
    </nav>
  </div>
</header>
